<div class="left-menu" [class.expanded]="!isCollapsed">
    <div class="menu-header">
        @if (!isCollapsed) {
            <img class="cursor-hand" [src]="logo$ | async" [tabindex]="0" (click)="goToHomepage()" (keydown.enter)="goToHomepage()" />
            <ui-icon-button iconName="close-left" size="small" [onSolidBackground]="true" (click)="collapseMenu()" />
        } @else {
            <div class="collapsed-header">
                <ui-icon-button iconName="menu" size="small" boundaries="icon" [onSolidBackground]="true" (click)="isCollapsed = false" />
            </div>
        }
    </div>

    <div class="menu-body">
        @for (item of mainItems; track $index) {
            <div class="body-item">
                <div
                    class="body-item-header"
                    role="menuitem"
                    [tabindex]="0"
                    [class.cursor-hand]="item.isExpandable || item.click"
                    (click)="item.click ? item.click() : toggleItem(item)"
                    (keydown.enter)="item.click ? item.click() : toggleItem(item)"
                >
                    <ui-icon [name]="item.iconName" [onBackground]="{ color: 'dark', derivation: 'main' }" />
                    @if (!isCollapsed) {
                        <span
                            >{{ item.name$ | async }}
                            @if (item.tagName) {
                                <ui-chip size="small" class="ml-2" [colorPalette]="'info' | colorPalette">
                                    {{ item.tagName }}
                                </ui-chip>
                            }
                        </span>
                        @if (item.isExpandable) {
                            <ui-icon-button
                                size="small"
                                [iconName]="item.isExpanded ? 'retract' : 'expand'"
                                [onSolidBackground]="true"
                                (keydown.enter)="item.click ? item.click() : toggleItem(item)"
                            />
                        }
                    }
                </div>
                <div class="body-item-children" [class.expanded]="item.isExpanded">
                    <div class="overflow-hidden">
                        @let currentPageValue = currentPage();
                        @if (!isCollapsed) {
                            @for (child of item.children; track $index) {
                                <div
                                    class="body-item-child"
                                    role="menuitem"
                                    [class.body-item-disabled]="child.isDisabled"
                                    [class.selected]="currentPageValue && child.matchingPages.includes(currentPageValue)"
                                    [tabindex]="0"
                                    (click)="child.click()"
                                    (keydown.enter)="child.click()"
                                >
                                    <div class="item-content">
                                        <div>{{ child.name$ | async }}</div>
                                        @if (child.iconName) {
                                            <ui-icon [name]="child.iconName" [onBackground]="{ color: 'dark', derivation: 'main' }" />
                                        }
                                        @if (child.tagName) {
                                            <ui-chip size="small" [colorPalette]="'info' | colorPalette">
                                                {{ child.tagName }}
                                            </ui-chip>
                                        }
                                    </div>
                                </div>
                            }
                        }
                    </div>
                </div>
            </div>
        }
    </div>

    @if (footerItems().length > 0) {
        <div class="menu-footer">
            <div class="footer-background" [class.collapsed]="isCollapsed">
                @for (item of footerItems(); track $index) {
                    <div class="footer-item" role="menuitem" [tabindex]="0" (click)="item.click()" (keydown.enter)="item.click()">
                        <ui-icon [name]="item.iconName" [onBackground]="{ color: 'dark', derivation: 'faded' }" />
                        @if (!isCollapsed) {
                            <span>{{ item.name | translate }}</span>
                        }
                    </div>
                }
            </div>
        </div>
    }
</div>
